import { createAction } from '../../store.model';
import { RowDto, TableDto } from '../../system-configuration/table-editor';

export enum ActionType {
    TABLE_EDITOR__RELOAD = 'TABLE_EDITOR__RELOAD',
    TABLE_EDITOR__RELOAD_RESULT = 'TABLE_EDITOR__RELOAD_RESULT',
    TABLE_EDITOR__RELOAD_CANCEL = 'TABLE_EDITOR__RELOAD_CANCEL',
    TABLE_EDITOR__RELOAD_ROWS = 'TABLE_EDITOR__RELOAD_ROWS',
    TABLE_EDITOR__RELOAD_ROWS_RESULT = 'TABLE_EDITOR__RELOAD_ROWS_RESULT',
    TABLE_EDITOR__RELOAD_ROWS_CANCEL = 'TABLE_EDITOR__RELOAD_ROWS_CANCEL',
    TABLE_EDITOR__CREATE_ROW = 'TABLE_EDITOR__CREATE_ROW',
    TABLE_EDITOR__CREATE_ROW_RESULT = 'TABLE_EDITOR__CREATE_ROW_RESULT',
    TABLE_EDITOR__CREATE_ROW_CANCEL = 'TABLE_EDITOR__CREATE_ROW_CANCEL',
    TABLE_EDITOR__DELETE_ROW = 'TABLE_EDITOR__DELETE_ROW',
    TABLE_EDITOR__DELETE_ROW_RESULT = 'TABLE_EDITOR__DELETE_ROW_RESULT',
    TABLE_EDITOR__DELETE_ROW_CANCEL = 'TABLE_EDITOR__DELETE_ROW_CANCEL',
    TABLE_EDITOR__CLEAR_MESSAGE = 'TABLE_EDITOR__CLEAR_MESSAGE',
}

export interface ReloadResult {
    tables?: TableDto[];
}

export const reload = createAction<ActionType, {}>(
    ActionType.TABLE_EDITOR__RELOAD,
);
export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.TABLE_EDITOR__RELOAD_RESULT,
);
export const reloadCancel = createAction<ActionType, {}>(
    ActionType.TABLE_EDITOR__RELOAD_CANCEL,
);

/// ///////

export interface ReloadRows {
    tableId: number;
}

export interface ReloadRowsResult extends ReloadRows {
    rows?: RowDto[];
}

export const reloadRows = createAction<ActionType, ReloadRows>(
    ActionType.TABLE_EDITOR__RELOAD_ROWS,
);
export const reloadRowsResult = createAction<ActionType, ReloadRowsResult>(
    ActionType.TABLE_EDITOR__RELOAD_ROWS_RESULT,
);
export const reloadRowsCancel = createAction<ActionType, {}>(
    ActionType.TABLE_EDITOR__RELOAD_ROWS_CANCEL,
);

/// ///////

export interface CreateRow {
    formValue: any;
}

export interface CreateRowResult extends CreateRow {
    success?: boolean;
    rows?: RowDto[];
}

export const createRow = createAction<ActionType, CreateRow>(
    ActionType.TABLE_EDITOR__CREATE_ROW,
);
export const createRowResult = createAction<ActionType, CreateRowResult>(
    ActionType.TABLE_EDITOR__CREATE_ROW_RESULT,
);
export const createRowCancel = createAction<ActionType, {}>(
    ActionType.TABLE_EDITOR__CREATE_ROW_CANCEL,
);

/// ///////

export interface DeleteRow {
    row: RowDto;
}

export interface DeleteRowResult extends DeleteRow {
    success?: boolean;
}

export const deleteRow = createAction<ActionType, DeleteRow>(
    ActionType.TABLE_EDITOR__DELETE_ROW,
);
export const deleteRowResult = createAction<ActionType, DeleteRowResult>(
    ActionType.TABLE_EDITOR__DELETE_ROW_RESULT,
);
export const deleteRowCancel = createAction<ActionType, {}>(
    ActionType.TABLE_EDITOR__DELETE_ROW_CANCEL,
);

/// ///////

export const clearMessage = createAction<ActionType, {}>(
    ActionType.TABLE_EDITOR__CLEAR_MESSAGE,
);
